import React, { useEffect, useState } from 'react'
import TopBar from '../components/menu/TopBar'
import Input from '../components/input/Input'
import AppintakeCard from '../components/appintake/AppintakeCard'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { language } from '../stores/slices/languageSlice'
import validateInput from '../utilities/validations/validateInput'
import { toast } from 'react-toastify'
import { fetchPreQualQuestion, resetPreQualQuestions, setPreQualQuestion } from '../stores/slices/preQual/preQualQuestionsSlice'
import { fetchPreQualFundsList, resetFundLists } from '../stores/slices/preQual/preQualFundsListSlice'
import { smartyStreetApi } from "../stores/slices/smartyStreetSlice"
import moment from "moment/moment";
import { fetchPreQualValidate, resetPreQualSubmitData, resetPreQualValidate, setPreQualData } from '../stores/slices/preQual/preQualValidateSlice'
import { fetchFundSpecificLookup } from '../stores/slices/preQual/fundSpecificLookupSlice'
import { Modal } from 'antd'
import { lookUp } from '../stores/slices/lookupSlice'
import { patientInfo, preQualData } from '../stores/slices/patientSearch/patientSearchSlice'
import { getAllSessions } from '../utilities/API/supertokenServices'

function PreQualification() {
    const patientInformation = useSelector((state) => state.patientSearchSlice.patientInformation);
    const selectedLanguage = useSelector(language).PreQual
    const errorMessage = useSelector(language).errorMessage
    const lookUpData = useSelector(lookUp);
    const fundList = useSelector(state => state.preQualFundsListSlice.value)
    const fundListStatus = useSelector(state => state.preQualFundsListSlice.status)
    const patientDetails = useSelector(state => state.patientSearchSlice)
    const preQualQuestionResponse = useSelector(state => state.preQualQuestionsSlice)
    const preQualStatus = useSelector(state => state.preQualValidateSlice)
    const portalUserId = useSelector(state => state.loginSlice.value.PortalUserID)
    const loginData = useSelector((state) => state.loginSlice);
    const sessionData = useSelector((state) => state.sessionSlice)
    const [isvalidAddress, setIsvalidAddress] = useState(false)
    const [modal, setModal] = useState(false)
    const [preScreenDetails, setPreScreenDetails] = useState({
        addressLine1: { value: "", isValid: true },
        addressLine2: { value: "", isValid: true },
        city: { value: "", isValid: true },
        state: { value: "", isValid: true },
        zipCode: { value: "", isValid: true },
        diagnosis: { value: "", isValid: true },
        insurance: { value: "", isValid: true },
        insuranceType: { value: "", isValid: true },
        fundsList: { value: "", isValid: true },
        smartyStreetMatches: {
            NoMatch: false,
            PartialMatch: false,
            SecInfoNotMatch: false,
            ExactMatch: false,
        },
        ss_msg_cls: '',
        ss_msg: '',
    })
    const [selectedFundDetails, setSelectedFundDetails] = useState({})
    const [validateMultiSelect, setValidateMultiSelect] = useState(true)
    const [preQualSubmitData, setPreQualSubmitData] = useState({})
    const navigate = useNavigate()
    const dispatch = useDispatch()

    let showFunds = preScreenDetails.diagnosis?.value != "" && preScreenDetails.insurance.value != "" && ((preScreenDetails.insurance.value == "yes" || preScreenDetails.insurance.value == "Yes") ? preScreenDetails.insuranceType.value != "" : true)

    useEffect(() => {
        setPreScreenDetails((prevState) => ({
            ...prevState,
            addressLine1: { value: patientInformation.address.addressLine1, isValid: true },
            addressLine2: { value: patientInformation.address.addressLine2, isValid: true },
            city: { value: patientInformation.address.city, isValid: true },
            state: { value: patientInformation.address.state, isValid: true },
            zipCode: { value: patientInformation.address.zipCode, isValid: true },
        }))
        dispatch(resetPreQualValidate())
        dispatch(resetPreQualQuestions())
        dispatch(resetFundLists())
        dispatch(resetPreQualSubmitData())
    }, [])

    useEffect(() => {
        const fundListPayload = {
            patientID: patientInformation.programSpecificPatientId,
            zipCode: preScreenDetails.zipCode.value,
            insuranceType: preScreenDetails.insuranceType.value,
            diagnosis: preScreenDetails.diagnosis.value,
            addressLine1: preScreenDetails.addressLine1.value,
            addressLine2: preScreenDetails.addressLine2.value,
            city: preScreenDetails.city.value,
            state: preScreenDetails.state.value,
            patientIsDeceased: 'No',
            DOB: moment(patientInformation.dateOfBirth).format('MM/DD/YYYY'),
            isNewPatient: patientDetails.newPatient,
            prgData: patientDetails.patientInformation.Program
        }
        showFunds && dispatch(fetchPreQualFundsList(fundListPayload))

    }, [showFunds, preScreenDetails])

    if (preQualStatus.success.isSuccess) {
        const fundSpecificLookupPayload = {
            prgData: patientDetails.patientInformation.Program,
            fundID: selectedFundDetails.fundID,
            fundGroup: selectedFundDetails.fundGroup,
        }
        dispatch(fetchFundSpecificLookup(fundSpecificLookupPayload))
        dispatch(setPreQualData({ insuranceType: preScreenDetails.insuranceType.value, diagnosis: preScreenDetails.diagnosis.value, fundId: selectedFundDetails.fundID, fundGroup: selectedFundDetails.fundGroup }))

        dispatch(resetPreQualValidate())
        dispatch(preQualData({ ...preScreenDetails, isvalidAddress }))
        return navigate('/createApp/appintake')
    }


    if (preQualStatus.failiure.isFailiure) {
        return navigate('/PreQualDenial')
    }

    const onClickVerifyAddress = () => {
        const validateAddress = preScreenDetails.addressLine1.value != "" && preScreenDetails.city.value != "" && preScreenDetails.state.value != "" && preScreenDetails.zipCode.value != "" && preScreenDetails.addressLine1.isValid && preScreenDetails.addressLine2.isValid && preScreenDetails.city.isValid && preScreenDetails.state.isValid && preScreenDetails.zipCode.isValid
        if (validateAddress) {
            const address = {
                addressLine1: preScreenDetails.addressLine1.value,
                addressLine2: preScreenDetails.addressLine2.value,
                city: preScreenDetails.city.value,
                state: preScreenDetails.state.value,
                zipCode: preScreenDetails.zipCode.value,
            };
            dispatch(smartyStreetApi({ address, callbackVerifiedAddress }));
            setIsvalidAddress(validateAddress)
        } else {
            toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
            setPreScreenDetails((prevState) => ({
                ...prevState,
                addressLine1: {
                    value: prevState.addressLine1.value,
                    isValid: prevState.addressLine1.isValid && prevState.addressLine1.value != '',
                },
                addressLine2: {
                    value: prevState.addressLine2.value,
                    isValid: prevState.addressLine2.isValid,
                },
                city: {
                    value: prevState.city.value,
                    isValid: prevState.city.isValid && prevState.city.value != '',
                },
                state: {
                    value: prevState.state.value,
                    isValid: prevState.state.isValid && prevState.state.value != '',
                },
                zipCode: {
                    value: prevState.zipCode.value,
                    isValid: prevState.zipCode.isValid && prevState.zipCode.value != '',
                }
            }));
        }
    }

    const callbackVerifiedAddress = (address) => {
        if (address?.isValidateAddress != undefined && address.isValidateAddress == "ExactMatch") {
            setPreScreenDetails((prevState) => ({
                ...prevState,
                addressLine1: {
                    value: address.street,
                    isValid: prevState.addressLine1.isValid,
                },
                addressLine2: {
                    value: address.street2,
                    isValid: prevState.addressLine2.isValid,
                },
                city: {
                    value: address.city,
                    isValid: prevState.city.isValid,
                },
                state: {
                    value: address.state,
                    isValid: prevState.state.isValid,
                },
                zipCode: {
                    value: address.zipcode,
                    isValid: prevState.zipCode.isValid,
                },
                smartyStreetMatches: {
                    NoMatch: address.NoMatch,
                    PartialMatch: address.PartialMatch,
                    SecInfoNotMatch: address.SecInfoNotMatch,
                    ExactMatch: address.ExactMatch,
                },
                ss_msg_cls: "ss_success",
                ss_msg: errorMessage.smartyStreetMsg.sucessMsg,
                isAddressVerified: true,
            }));

        } else {
            setPreScreenDetails((prevState) => ({
                ...prevState,
                addressLine1: {
                    value: address.street,
                    isValid: prevState.addressLine1.isValid,
                },
                addressLine2: {
                    value: address.street2,
                    isValid: prevState.addressLine2.isValid,
                },
                city: {
                    value: address.city,
                    isValid: prevState.city.isValid,
                },
                state: {
                    value: address.state,
                    isValid: prevState.state.isValid,
                },
                zipCode: {
                    value: address.zipcode,
                    isValid: prevState.zipCode.isValid,
                },
                smartyStreetMatches: {
                    NoMatch: address.NoMatch,
                    PartialMatch: address.PartialMatch,
                    SecInfoNotMatch: address.SecInfoNotMatch,
                    ExactMatch: address.ExactMatch,
                },
                ss_msg_cls: "ss_error",
                ss_msg: errorMessage.smartyStreetMsg.errorMsg,
                isAddressVerified: true,


            }));
        }
    }

    // Validating each of the fields and updating those value into state
    const inputOnChange = (e, fieldvalidation) => {
        let inputValue = e.target.value;
        let name = e.target.name;
        let inputValidate = validateInput(inputValue, fieldvalidation);
        setPreScreenDetails((prevState) => ({
            ...prevState,
            [name]: {
                value: inputValidate.value,
                isValid: inputValidate.isValid,
            },
        }));

        if (name == "addressLine1" || name == "addressLine2" || name == "city" || name == "state" || name == "zipCode") {
            setPreScreenDetails((prevState) => ({
                ...prevState,
                diagnosis: {
                    value: '',
                    isValid: true,
                },
                insurance: {
                    value: '',
                    isValid: true,
                },
                insuranceType: {
                    value: '',
                    isValid: true,
                },
                fundsList: {
                    value: '',
                    isValid: true,
                },
                smartyStreetMatches: {
                    NoMatch: false,
                    PartialMatch: false,
                    SecInfoNotMatch: false,
                    ExactMatch: false,
                },
                ss_msg_cls: '',
                ss_msg: '',
            }))
            setIsvalidAddress(false)
            showFunds = false
            dispatch(resetPreQualQuestions())
            dispatch(resetFundLists())
        } else if (name == "diagnosis" || name == "insuranceType" || name == "insurance") {
            setPreScreenDetails((prevState) => ({
                ...prevState,
                fundsList: {
                    value: '',
                    isValid: true,
                },
            }))
            dispatch(resetPreQualQuestions())
            dispatch(resetFundLists())
        } else if (name == "fundsList") {
            dispatch(resetPreQualQuestions())
            const fundDetails = fundList.find(data => data.fundID == e.target.value)
            setSelectedFundDetails(fundDetails)
            const preQualPayload = {
                patientID: patientInformation.programSpecificPatientId,
                zipCode: preScreenDetails.zipCode.value,
                addressLine1: preScreenDetails.addressLine1.value,
                addressLine2: preScreenDetails.addressLine2.value,
                city: preScreenDetails.city.value,
                state: preScreenDetails.state.value,
                isNewPatient: patientDetails.newPatient,
                fundID: fundDetails.fundID,
                fundGroup: fundDetails.fundGroup,
                prgData: patientDetails.patientInformation.Program
            }
            dispatch(fetchPreQualQuestion(preQualPayload))
        }
    }



    const preQualSubmit = () => {
        const prequalValidate = []
        const additionalValidate = []
        let validateDropDownPreQual = true
        let validateDropDownAdditional = true

        if (isvalidAddress && showFunds && preScreenDetails.fundsList.value) {
            preQualQuestionResponse?.preQualQuestions?.map((data, i) => {
                let obj = {}
                if (data?.AnswerType == "YesNo") {
                    obj = data.GroupID != undefined ? {
                        AnswerType: data.AnswerType,
                        ID: data.ID,
                        Question: data.Question,
                        pxObjClass: data.pxObjClass,
                        YesNoAnswer: data.YesNoAnswer,
                        GroupID: data.GroupID
                    } : {
                        AnswerType: data.AnswerType,
                        ID: data.ID,
                        Question: data.Question,
                        pxObjClass: data.pxObjClass,
                        YesNoAnswer: data.YesNoAnswer,
                    };
                } else if (data?.AnswerType == "Drop-down") {
                    data.Answer == undefined && dispatch(setPreQualQuestion({
                        index: i,
                        questionType: 'Answer',
                        answer: "",
                        name: "preQual"
                    }))

                    validateDropDownPreQual = data.Answer != undefined && data.Answer != ""

                    obj = data.GroupID != undefined ? {
                        Answer: data.Answer,
                        AnswerType: data.AnswerType,
                        ID: data.ID,
                        pxObjClass: data.pxObjClass,
                        Question: data?.Question,
                        GroupID: data?.GroupID,
                    } : {
                        Answer: data.Answer,
                        AnswerType: data.AnswerType,
                        ID: data.ID,
                        pxObjClass: data.pxObjClass,
                        Question: data?.Question,
                    }
                }
                prequalValidate.push(obj)
            })

            preQualQuestionResponse?.additionalQuestions?.map((data, i) => {
                let obj = {}
                if (data?.AnswerType == "YesNo") {
                    obj = data.GroupID != undefined ? {
                        AnswerType: data.AnswerType,
                        ID: data.ID,
                        Question: data.Question,
                        pxObjClass: data.pxObjClass,
                        YesNoAnswer: data.YesNoAnswer,
                        GroupID: data.GroupID
                    } : {
                        AnswerType: data.AnswerType,
                        ID: data.ID,
                        Question: data.Question,
                        pxObjClass: data.pxObjClass,
                        YesNoAnswer: data.YesNoAnswer,
                    };
                    additionalValidate.push(obj)
                } else if (data?.AnswerType == "Drop-down") {
                    data.Answer == undefined && dispatch(setPreQualQuestion({
                        index: i,
                        questionType: 'Answer',
                        answer: "",
                    }))
                    validateDropDownAdditional = data.Answer != undefined && data.Answer != ""
                    obj = data.GroupID != undefined ? {
                        Answer: data.Answer,
                        AnswerType: data.AnswerType,
                        ID: data.ID,
                        pxObjClass: data.pxObjClass,
                        Question: data?.Question,
                        GroupID: data?.GroupID,
                    } : {
                        Answer: data.Answer,
                        AnswerType: data.AnswerType,
                        ID: data.ID,
                        pxObjClass: data.pxObjClass,
                        Question: data?.Question,
                    }
                    additionalValidate.push(obj)
                } else {
                    const answerList = []
                    data.AnswersList.map((val) => {
                        val.isChecked && answerList.push({
                            Answer: val.value,
                            pxObjClass: "PAF-Data-QuestionsCatalogue-Answers"
                        })
                    })
                    setValidateMultiSelect(answerList.length > 0)
                    obj = {
                        AnswerType: data.AnswerType,
                        ID: data.ID,
                        pxObjClass: "PAF-Data-QuestionsCatalogue",
                        Question: data.Question,
                        AnswersList: answerList
                    }
                    additionalValidate.push(obj)
                }
            })

            let prequalObj = {
                FundInsKey: selectedFundDetails?.fundInsKey,
                FundID: selectedFundDetails?.fundID,
                FundName: selectedFundDetails?.fundName,
                PortalUserID: portalUserId,
                PortalType: 'Provider',
                InsuranceType: preScreenDetails.insuranceType.value,
                Diagnosis: preScreenDetails.diagnosis.value,

                PatientInformation: {
                    FirstName: patientInformation.firstName,
                    LastName: patientInformation.lastName,
                    ContactId: patientInformation.programSpecificPatientId,
                    DOB: moment(patientInformation.dateOfBirth).format('MM/DD/YYYY'),
                    SSN: patientInformation.ssn,
                    AlienNumber: patientInformation.alienNumber,
                    IsUndocumented: "false",
                    IsDeceased: "false",
                    Address: [
                        {
                            "AddressLine1": preScreenDetails.addressLine1.value,
                            "AddressLine2": preScreenDetails.addressLine2.value,
                            "City": preScreenDetails.city.value,
                            "Country": "US",
                            "pzIndexOwnerKey": "PAF-DATA-PATIENT 3178",
                            "State": preScreenDetails.state.value,
                            "ZipCode": preScreenDetails.zipCode.value
                        }
                    ]
                },
                PreQualQuestionsList: prequalValidate
            }
            if (additionalValidate.length > 0) {
                Object.assign(prequalObj, {
                    AdditionalDataQuestionsList: additionalValidate
                })
            }
            if (validateMultiSelect && validateDropDownPreQual && validateDropDownAdditional) {
                setPreQualSubmitData(prequalObj)
                setModal(true)
            } else {
                toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
            }
        } else {
            toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
        }
    }

    const handleMultiSelect = (e, i, index, length) => {
        const tempArr = []
        preQualQuestionResponse?.additionalQuestions[i].AnswersList.map((data) => {
            data.isChecked && tempArr.push("true")
        })
        if (e.target.checked && (tempArr.length + 1) > Number(length)) {
            toast.error("You have selected the maximum allowed response for this question!")
        } else {
            dispatch(setPreQualQuestion({
                name: 'multiSelect',
                index: i,
                index2: index,
                answer: e.target.checked
            }))
        }
    }

    const preQualValidate = () => {
        setModal(false)
            dispatch(fetchPreQualValidate({ prequalObj: preQualSubmitData, prgData: patientDetails.patientInformation.Program }))

    }
    let addressLine2 = preScreenDetails.addressLine2.value.length > 2 ? preScreenDetails.addressLine2.value + "," : ''
    return (
        <div className="content">
            <TopBar />
            <div className="g-col-12 g-col-xxl-9">
                <AppintakeCard flow={{ flow: 'Application' }} />
                {/* <!-- BEGIN: Wizard Layout --> */}
                <div className="intro-y box py-1 py-sm-4 mt-5">
                    <div className="d-flex justify-content-center">
                        <div className="px-5 mt-1">
                            <div className="fw-medium text-center fs-lg" data-testid="heading">{selectedLanguage.heading}</div>
                            <div className="text-gray-600 text-center mt-2" data-testid="subHeading">{selectedLanguage.subHeading}</div>
                        </div>
                    </div>
                    <div className="px-5 px-sm-20 mt-5 pt-10 border-top border-gray-200 dark-border-dark-5 p-8">
                        <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
                            <i data-feather="home"></i><p className="p-1 ps-3 text-theme-1" data-testid="addressHeading">{selectedLanguage.addressInformation.heading}</p>
                        </div>
                        <div className="grid columns-12 gap-4 gap-y-5 mt-5 p" >
                            <Input
                                type="text"
                                id="addressLine1"
                                label={selectedLanguage.addressInformation.addressLine1}
                                name="addressLine1"
                                value={preScreenDetails.addressLine1.value}
                                isValid={preScreenDetails.addressLine1.isValid}
                                onChange={(e) => inputOnChange(e, "address")}
                                maxLength="100"
                                errorMsg={errorMessage?.inputErrorMessage}
                            />
                            <Input
                                type="text"
                                id="addressLine2"
                                label={selectedLanguage.addressInformation.addressLine2}
                                name="addressLine2"
                                value={preScreenDetails.addressLine2.value}
                                isValid={preScreenDetails.addressLine2.isValid}
                                onChange={(e) => inputOnChange(e, "addressLine2")}
                                maxLength="100"
                                errorMsg={errorMessage?.inputErrorMessage}
                            />
                            <Input
                                type="text"
                                id="city"
                                label={selectedLanguage.addressInformation.city}
                                name="city"
                                value={preScreenDetails.city.value}
                                isValid={preScreenDetails.city.isValid}
                                onChange={(e) => inputOnChange(e, "city")}
                                maxLength="50"
                                errorMsg={errorMessage?.inputErrorMessage}
                            />
                            <Input
                                type="select"
                                id="state"
                                label={selectedLanguage.addressInformation.state}
                                name="state"
                                value={preScreenDetails.state.value}
                                isValid={preScreenDetails.state.isValid}
                                onChange={(e) => inputOnChange(e, "state")}
                                maxLength="100"
                                errorMsg={errorMessage?.inputErrorMessage}
                                elmentconfig={lookUpData.State}
                            />
                            <Input
                                type="text"
                                id="zipCode"
                                label={selectedLanguage.addressInformation.zipcode}
                                name="zipCode"
                                value={preScreenDetails.zipCode.value}
                                isValid={preScreenDetails.zipCode.isValid}
                                onChange={(e) => inputOnChange(e, "zipcode")}
                                maxLength="5"
                                errorMsg={errorMessage?.inputErrorMessage}
                            />
                            <div className={`${preScreenDetails.ss_msg_cls} intro-y g-col-12 g-col-md-12 g-col-xl-12 mt-4 text-center`}>
                                {preScreenDetails.ss_msg}
                                <div className="intro-y g-col-12 g-col-sm-12 text-center mt-1"><button className="btn verifyAddres ms-2 z-10" type="submit" onClick={onClickVerifyAddress} data-testid="verifyAddress">{selectedLanguage.addressInformation.verifyAddress}</button></div>
                            </div>
                        </div>
                        {isvalidAddress && <div>
                            <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3 mt-8">
                                <i data-feather="user"></i><p className="p-1 ps-3 text-theme-1" data-testid="medicalHeading"> {selectedLanguage.medicalInformation.heading} </p>
                            </div>
                            <div className="grid columns-12 gap-4 gap-y-5 mt-5">
                                <Input
                                    type="select"
                                    id="diagnosis"
                                    label={selectedLanguage.medicalInformation.diagnosis}
                                    name="diagnosis"
                                    value={preScreenDetails.diagnosis.value}
                                    isValid={preScreenDetails.diagnosis.isValid}
                                    onChange={(e) => inputOnChange(e, "dropDown")}
                                    maxLength="100"
                                    errorMsg={errorMessage?.inputErrorMessage}
                                    elmentconfig={lookUpData.patientDiagnosis}
                                />
                                <div className='intro-y g-col-6 g-col-md-6 g-col-xl-8'></div>
                                <div className="intro-y g-col-12 g-col-md-12 g-col-xl-8">
                                    <Input
                                        type="select"
                                        id="insurance"
                                        label={selectedLanguage.medicalInformation.insurance}
                                        name="insurance"
                                        value={preScreenDetails.insurance.value}
                                        isValid={preScreenDetails.insurance.isValid}
                                        onChange={(e) => inputOnChange(e, "address")}
                                        maxLength="100"
                                        errorMsg={errorMessage?.inputErrorMessage}
                                        elmentconfig={[{ key: "yes", value: 'Yes' }, { key: "no", value: 'No' }]}
                                    />
                                </div>
                                {(preScreenDetails.insurance?.value == "Yes" || preScreenDetails.insurance?.value == "yes") && <Input
                                    type="select"
                                    id="insuranceType"
                                    label={selectedLanguage.medicalInformation.insuranceType}
                                    name="insuranceType"
                                    value={preScreenDetails.insuranceType.value}
                                    isValid={preScreenDetails.insuranceType.isValid}
                                    onChange={(e) => inputOnChange(e, "dropDown")}
                                    maxLength="100"
                                    errorMsg={errorMessage?.inputErrorMessage}
                                    elmentconfig={lookUpData.insuranceType}
                                />}
                            </div>
                            {(showFunds && fundList[0]?.fundName != "--") ? <div className="grid columns-12 gap-4 gap-y-5 mt-14">
                                <Input
                                    type="select"
                                    id="fundsList"
                                    label={selectedLanguage.medicalInformation.fund}
                                    name="fundsList"
                                    value={preScreenDetails.fundsList.value}
                                    isValid={preScreenDetails.fundsList.isValid}
                                    onChange={(e) => inputOnChange(e, "dropDown")}
                                    maxLength="100"
                                    errorMsg={errorMessage?.inputErrorMessage}
                                    elmentconfig={fundList}
                                />
                            </div>:<>
                                {fundListStatus && <div className="content_prescreen">
                                    <div className="g-col-12 g-col-xxl-9">
                                        <div className="intro-y box py-1 py-sm-2 mt-5 bg-danger g-col-6 g-col-xxl-6">
                                            <div className="d-flex justify-content-center">
                                                <div className="mt-1">
                                                    <div className="fw-medium text-center fs-lg" data-testid="heading">Ineligible due to program guidelines</div>
                                                </div>
                                            </div>
                                        </div>
                                         <div className="grid columns-12 gap-4 gap-y-5 mt-5 p">
                                            <div className={`intro-y g-col-1 g-col-md-2 g-col-xl-2 px-8 `}></div>
                                            <p className={`intro-y g-col-10 g-col-md-8 g-col-xl-8 `}>Based on the information provided, there are no grants available that the patient is eligible for at this time.</p>
                                        </div>
                                        <div className="grid columns-12 gap-4 gap-y-5 mt-5 p">
                                            <div className={`intro-y g-col-1 g-col-md-2 g-col-xl-2 px-8 `}></div>
                                            <p className={`intro-y g-col-10 g-col-md-8 g-col-xl-8 `}><b>Please retain this information for your records. If you feel you received this message in error or your circumstances change in the future, please feel free to contact the program at {patientDetails.patientInformation.Program == "CPR" ? '866-512-3861' : '855-824-7941'} so that a program specialist can assist you.</b></p>
                                        </div>
                                    </div>
                                </div>}</>
                            }
                            {preQualQuestionResponse.isPreQualQuesAvailable && preQualQuestionResponse?.preQualQuestions.map((prequalQuestion, i) => {
                                return (<React.Fragment>
                                    {prequalQuestion?.AnswerType == "YesNo" && <div className=" mt-14">
                                        <Input
                                            type="switch1"
                                            id={`preQual${i + 1}`}
                                            labelPosition="left"
                                            name="preQual"
                                            label={prequalQuestion?.Question}
                                            value={prequalQuestion?.YesNoAnswer == 'Yes' ? true : false}
                                            onClick={(e) => dispatch(setPreQualQuestion({
                                                index: i,
                                                questionType: 'YesNoAnswer',
                                                answer: e.target.checked ? 'Yes' : 'No',
                                                name: "preQual"
                                            }))}
                                        />
                                    </div>}
                                    {prequalQuestion?.AnswerType == "Drop-down" && <div className="grid columns-12 gap-4 gap-y-5 mt-14">
                                        <p className='intro-y g-col-12 g-col-md-9 g-col-xl-6 px-8 py-8'>{prequalQuestion?.Question}</p>
                                        <Input
                                            type="select"
                                            id={`dropDown${i + 1}`}
                                            name={`dropDown${i + 1}`}
                                            value={prequalQuestion.Answer}
                                            isValid={prequalQuestion.Answer != undefined ? (prequalQuestion.Answer != "" && prequalQuestion.Answer) : true}
                                            onChange={(e) => dispatch(setPreQualQuestion({
                                                index: i,
                                                questionType: 'Answer',
                                                answer: e.target.value,
                                                name: "preQual"
                                            }))}
                                            errorMsg={errorMessage?.inputErrorMessage}
                                            elmentconfig={prequalQuestion?.AnswersList?.map(answer => ({ key: answer.Answer, value: answer.Answer }))}
                                        />
                                    </div>}
                                </React.Fragment>)
                            })}
                            {preQualQuestionResponse.isPreQualQuesAvailable && preQualQuestionResponse?.additionalQuestions?.map((additionalQuestion, i) => {
                                return <React.Fragment>
                                    {additionalQuestion?.AnswerType == "YesNo" && <div className="mt-14">
                                        <Input
                                            type="switch1"
                                            id={`additional${i + 1}`}
                                            labelPosition="left"
                                            name="additional"
                                            label={additionalQuestion?.Question}
                                            value={additionalQuestion?.YesNoAnswer == 'Yes' ? true : false}
                                            onClick={(e) => dispatch(setPreQualQuestion({
                                                index: i,
                                                questionType: 'YesNoAnswer',
                                                answer: e.target.checked ? 'Yes' : 'No'
                                            }))}
                                        />
                                    </div>}
                                    {additionalQuestion?.AnswerType == "Drop-down" && <div className="grid columns-12 gap-4 gap-y-5 mt-14">
                                        <p className='intro-y g-col-12 g-col-md-9 g-col-xl-6 px-8 py-8'>{additionalQuestion?.Question}</p>
                                        <Input
                                            type="select"
                                            id={`dropDown${i + 1}`}
                                            name={`dropDown${i + 1}`}
                                            value={additionalQuestion?.Answer}
                                            isValid={additionalQuestion.Answer != undefined ? (additionalQuestion.Answer != "" && additionalQuestion.Answer) : true}
                                            onChange={(e) => dispatch(setPreQualQuestion({
                                                index: i,
                                                questionType: 'Answer',
                                                answer: e.target.value
                                            }))}
                                            errorMsg={errorMessage?.inputErrorMessage}
                                            elmentconfig={additionalQuestion?.AnswersList?.map(answer => ({ key: answer.Answer, value: answer.Answer }))}
                                        />
                                    </div>}
                                    {additionalQuestion?.AnswerType == "Multi-select" && <div className="grid columns-12 gap-4 gap-y-5 mt-14">
                                        <p className='intro-y g-col-12 g-col-md-9 g-col-xl-6 px-8'>{additionalQuestion?.Question}</p>
                                        <div className="intro-y g-col-3 g-col-sm-3">
                                            {additionalQuestion?.AnswersList?.map((answerList, index) => {
                                                return <React.Fragment>
                                                    <input
                                                        className="form-check-input mt-2"
                                                        checked={answerList.isChecked}
                                                        name={"additionalQues"}
                                                        type="checkbox"
                                                        value={answerList.value}
                                                        onChange={(e) => { handleMultiSelect(e, i, index, additionalQuestion.MaximumNumberOfAllowableAnswers) }}
                                                    />
                                                    <label className="form-check-label mt-2">
                                                        {answerList.value}
                                                    </label><br />
                                                </React.Fragment>
                                            })}
                                            <p className='mt-2 color-danger'>{!validateMultiSelect && "Please select atleast one"}</p>
                                        </div>
                                    </div>}
                                </React.Fragment>
                            })}
                            {preQualQuestionResponse.isPreQualQuesAvailable && <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                                <button className="btn verifyAddres w-24 ms-2" data-testid="submit" onClick={preQualSubmit}>{selectedLanguage.submit}</button>
                            </div>}
                        </div>}
                    </div>
                </div>
            </div>
            <Modal
                open={modal}
                title=''
                onOk={preQualValidate}
                onCancel={() => {
                    setModal(false)
                }}
                cancelText="CONTINUE EDITING"
                okText="CONFIRM"
                className='myModal'
                maskClosable={false}
                closable={false}
                width={550}
                centered

            >
                <span className='modal_style'>
                    <p className='fw-bolder'>Please review the address information entered is correct, then hit confirm.</p>
                    <div className='d-flex mt-2'>
                        <p className='fw-bolder'>Patient Name:</p>&nbsp;&nbsp;
                        <p>{patientInformation.firstName + " " + patientInformation.lastName}</p>
                    </div>
                    <div className='d-flex mt-2'>
                        <p className='fw-bolder'>Address:</p>&nbsp;&nbsp;&nbsp;
                        <div>
                            <p>{preScreenDetails.addressLine1.value + "," + addressLine2}</p>
                            <p>{preScreenDetails.city.value + "," + preScreenDetails.state.value + "," + preScreenDetails.zipCode.value}</p>
                        </div>
                    </div>
                </span>
            </Modal>
        </div >
    )
}

export default PreQualification